// Pathfinder Unchained Variant Multiclassing — Paladin archetype benefit tiers.
const paladinArchetype = [
	{
		level: 1,
		name: 'Code',
		description: "You must follow the paladin's code of conduct and gain the paladin's aura of good.",
	},
	{
		level: 3,
		name: 'Detect Evil',
		description: 'You can detect evil, as a 1st-level paladin.',
	},
	{
		level: 7,
		name: 'Lay on Hands',
		description: 'You gain the ability to lay on hands a number of times per day equal to 1/2 your character level, healing as much as a paladin of your character level – 4.',
	},
	{
		level: 11,
		name: 'Smite Evil',
		description: 'You gain the ability to smite evil once per day, as a paladin of your character level – 4.',
	},
	{
		level: 15,
		name: 'Mercy',
		description: "You select one mercy from the paladin's 3rd-level mercy list.",
	},
	{
		level: 19,
		name: 'Divine Bond',
		description: 'You gain a divine bond to a weapon, as a paladin of your character level – 3.',
	},
];

export default paladinArchetype;
